// The Story of Jeinar - Translations
const jeinarStoryTranslations = {
  // Page meta
  pageTitle: {
    fr: "Le Récit de Jeinar",
    en: "The Story of Jeinar"
  },
  
  // Hero section
  hero: {
    subtitle: {
      fr: "Un déploiement sacré",
      en: "A Sacred Unfolding"
    }
  },

  // Opening
  opening: {
    p1: {
      /* ═══ CONSERVATION TEMPORAIRE ═══
      fr: "Il était une fois une femme qui brillait sans voir sa propre lumière.",
      en: "Once upon a time, there was a woman\nwho shone brightly without seeing her own light."
      ═══ FIN CONSERVATION TEMPORAIRE ═══ */
      fr: "Il y a eu un avant.\nEt il y a eu une rupture.",
      en: "There was a before.\nAnd there was a breaking point."
    },
    p2: {
      fr: "On la disait rayonnante. Infatigable. Magnétique.\nElle donnait sans compter. Créait sans limite. Aimait sans relâche.",
      en: "People called her radiant.\nTireless.\nMagnetic.\n\nShe gave without counting.\nCreated without limits.\nLoved without holding back."
    },
    p3: {
      fr: "Et pourtant, à l'intérieur, quelque chose de silencieux grandissait.",
      en: "And yet, inside, something quiet was growing."
    },
    p4: {
      fr: "Pas un manque.\nUne invitation.",
      en: "Not a lack.\n\nAn invitation."
    },
    p5: {
      fr: "L'âme qui frappe doucement à la porte\nquand la vie que l'on s'est construite devient trop étroite\npour contenir la vérité.",
      en: "The soul knocking softly at the door\nwhen the life we have built\nbecomes too narrow\nto hold our truth."
    },
    greeting: {
      fr: "Aloha,\nje m'appelle Jeinar.",
      en: "Aloha,\n\nmy name is Jeinar."
    }
  },

  // Origins
  origins: {
    title: {
      fr: "Origines",
      en: "Origins"
    },
    p1: {
      fr: "Je suis née à Puerto Tejada, en Colombie,\net adoptée par des parents suisses.",
      en: "I was born in Puerto Tejada, Colombia,\nand adopted by Swiss parents."
    },
    p2: {
      fr: "Pendant de nombreuses années, j'ai vécu sous un autre nom.\nCaroline.",
      en: "For many years,\nI lived under another name.\n\nCaroline."
    },
    p3: {
      fr: "Un nom qui appartenait à la vie que je pensais devoir vivre.",
      en: "A name that belonged to the life\nI thought I was supposed to live."
    },
    p4: {
      fr: "En 2011, je suis arrivée à Bali.",
      en: "In 2011, I arrived in Bali."
    },
    p5: {
      fr: "De l'extérieur, tout semblait parfait.\nUne histoire d'amour.\nUne villa magnifique.\nUne vie qui ressemblait à un rêve.",
      en: "From the outside, everything seemed perfect.\n\nA love story.\nA beautiful villa.\nA life that looked like a dream."
    },
    p6: {
      fr: "Mais ce que je ne voyais pas alors,\nc'est que j'avais construit un temple pour les apparences,\npas pour la vérité.",
      en: "But what I could not see then\nwas that I had built a temple for appearances,\nnot for truth."
    },
    p7: {
      fr: "Je construisais à l'extérieur\nce que je n'avais jamais osé rencontrer à l'intérieur.",
      en: "I was building outside\nwhat I had never dared to meet within."
    },
    p8: {
      fr: "Moi-même.",
      en: "Myself."
    }
  },

  // The Moment
  theMoment: {
    title: {
      fr: "Le moment où tout a basculé",
      en: "The moment everything changed"
    },
    p1: {
      fr: "Une nuit, tout s'est fissuré.",
      en: "One night, everything cracked open."
    },
    p2: {
      fr: "La façade s'est effondrée.\nL'illusion s'est dissoute.\nLe cœur s'est ouvert.",
      en: "The façade collapsed.\nThe illusion dissolved.\nThe heart opened."
    },
    p3: {
      fr: "Et dans cette fracture,\nj'ai entendu un seul mot :",
      en: "And inside that fracture,\none word appeared."
    },
    p4: {
      fr: "Assez.",
      en: "Enough."
    },
    p5: {
      fr: "J'ai quitté la maison.\nLa relation.\nLa vie qui ne m'appartenait plus.",
      en: "I left the house.\nThe relationship.\nThe life that no longer belonged to me."
    },
    p6: {
      fr: "Avec mon plus jeune fils\net une valise remplie de silence,\nj'ai traversé vers l'autre côté de l'île.",
      en: "With my youngest son\nand a suitcase filled with silence,\nI crossed to the other side of the island."
    },
    p7: {
      fr: "Et là, dans ce vide,\nj'ai commencé à respirer pour de vrai.",
      en: "And in that emptiness,\nI began to breathe again."
    }
  },

  // Silence
  silence: {
    title: {
      fr: "La descente dans le silence",
      en: "The descent into silence"
    },
    p1: {
      fr: "Au début, le silence m'effrayait.",
      en: "At first, silence frightened me."
    },
    p2: {
      fr: "Puis il m'a tenue.\nPuis il m'a parlé.",
      en: "Then it held me.\nThen it spoke."
    },
    p3: {
      fr: "J'ai découvert que le silence n'est pas une absence.",
      en: "I discovered that silence is not an absence."
    },
    p4: {
      fr: "C'est la présence pure.",
      en: "It is presence."
    },
    p5: {
      fr: "Dans cet espace, j'ai rencontré la femme cachée derrière les rôles.",
      en: "In that space, I met the woman\nwho had been hidden behind the roles."
    },
    p6: {
      fr: "La femme.\nLa sagesse.\nLa médecine.",
      en: "The woman.\nThe wisdom.\nThe medicine."
    },
    p7: {
      fr: "Chaque jour est devenu un rituel.",
      en: "Each day became a ritual."
    },
    p8: {
      fr: "Marcher au lever du soleil.\nRespirer.\nÉcrire.\nRemercier.\nDanser.",
      en: "Walking at sunrise.\nBreathing.\nWriting.\nGiving thanks.\nDancing."
    },
    p9: {
      fr: "Lentement, j'ai appris à me choisir.",
      en: "And slowly,\nI learned to choose myself."
    }
  },

  // Becoming
  becoming: {
    title: {
      fr: "Devenir Jeinar",
      en: "Becoming Jeinar"
    },
    p1: {
      fr: "J'ai cessé d'attendre l'amour\net j'ai commencé à le devenir.",
      en: "I stopped waiting for love.\n\nAnd I began to become it."
    },
    p2: {
      fr: "La féminité que j'avais cachée sous la performance est revenue.",
      en: "The femininity I had hidden beneath performance returned."
    },
    p3: {
      fr: "Mon corps s'est assoupli.\nMa voix s'est adoucie.\nMa vie s'est ouverte.",
      en: "My body softened.\nMy voice gentled.\nMy life opened."
    },
    p4: {
      fr: "J'ai cessé d'être une femme qui fait.",
      en: "I was no longer a woman who performs."
    },
    p5: {
      fr: "Je suis devenue une femme qui vibre.",
      en: "I became a woman who vibrates."
    },
    p6: {
      fr: "Et quelque chose d'extraordinaire a commencé à se produire.",
      en: "And this is when Caroline faded,\nand Jeinar emerged."
    },
    p7: {
      fr: "Les gens ont commencé à dire :\n\n« Tu dois partager.\nCe que tu portes est nécessaire dans ce monde. »",
      en: "People started saying:\n\n\"You must share.\nWhat you carry is needed in this world.\""
    },
    p8: {
      fr: "C'est alors que Caroline s'est effacée\net que Jeinar a émergé.",
      en: "The name my biological parents\ngave me at birth."
    },
    p9: {
      fr: "Le nom que mes parents biologiques m'ont donné à la naissance.",
      en: "A name that unites two worlds:"
    },
    p10: {
      fr: "Un nom qui unit deux mondes :\n\nla douceur de la prière\net la puissance de la lumière.",
      en: "the softness of prayer\nand the power of light."
    }
  },

  // Living Ritual
  livingRitual: {
    title: {
      fr: "Une vie comme rituel vivant",
      en: "A life as a living ritual"
    },
    p1: {
      fr: "Depuis, ma vie est devenue un rituel vivant.",
      en: "Since then, my life has become a living ritual."
    },
    p2: {
      fr: "Pendant des années, j'ai mis mes alarmes sur les heures miroirs :\n\n7h07\n8h08\n9h09",
      en: "For years,\nI set my alarms on mirror hours:\n\n7:07\n8:08\n9:09"
    },
    p3: {
      fr: "À chaque fois, je faisais une pause d'une minute.",
      en: "Each time, I paused for one minute."
    },
    p4: {
      fr: "Une minute pour respirer.\nUne minute pour remercier.\nUne minute pour me réaligner.",
      en: "To breathe.\nTo give thanks.\nTo realign."
    },
    p5: {
      fr: "Un geste simple.",
      en: "A simple gesture."
    },
    p6: {
      fr: "Pourtant, c'est devenu ma prière moderne.",
      en: "And yet it became my modern prayer."
    },
    p7: {
      fr: "Une façon de me rappeler que tout commence ici.",
      en: "A reminder that everything begins here."
    },
    p8: {
      fr: "Maintenant.",
      en: "Now."
    }
  },

  // What I Offer
  whatIOffer: {
    title: {
      fr: "Ce que j'offre aujourd'hui",
      en: "What I offer today"
    },
    p1: {
      fr: "Aujourd'hui, je n'enseigne pas une méthode.",
      en: "Today, I do not teach a method."
    },
    p2: {
      fr: "Je marche à côté.",
      en: "I walk beside."
    },
    p3: {
      fr: "Je tiens des espaces où les coconé·es peuvent respirer à nouveau.\nOù le corps s'assouplit.\nOù la vérité apparaît naturellement.",
      en: "I hold spaces where people can breathe again.\n\nWhere the body softens.\nWhere truth appears."
    },
    p4: {
      fr: "Mon travail réunit soins énergétiques intuitifs, guidance par les oracles, messages canalisés et présence incarnée.",
      en: "My work weaves together intuitive energy healing, oracle guidance, channeled messages and embodied presence."
    },
    p5: {
      fr: "Pas comme des techniques.",
      en: "Not as techniques."
    },
    p6: {
      fr: "Mais comme des façons d'écouter plus profondément.",
      en: "But as ways of listening more deeply."
    },
    p7: {
      fr: "À travers retraites, cérémonies, immersions et cercles intimes,\nje crée des espaces où les coconé·es se reconnectent à leur propre guidance intérieure.",
      en: "Through retreats, ceremonies, immersions and intimate circles,\nI create spaces where people reconnect with their own inner guidance."
    },
    p8: {
      fr: "Des espaces sans performance.\nSans pression.\nSans masques.",
      en: "No performance.\nNo pressure.\nNo masks."
    },
    p9: {
      fr: "Juste la présence.",
      en: "Just presence."
    },
    p10: {
      fr: "Juste la vérité.",
      en: "Just truth."
    },
    p11: {
      fr: "Juste la vie qui circule à nouveau.",
      en: "Just life moving again."
    }
  },

  // Closing
  closing: {
    title: {
      fr: "Si ma vie devait se résumer",
      en: "If my life could be expressed in one sentence"
    },
    p1: {
      fr: "Si toute ma vie devait s'exprimer en une seule phrase,\nce serait simplement celle-ci :",
      en: "If my life had to be summed up in a single sentence:"
    },
    p2: {
      fr: "Merci pour l'expérience.",
      en: "Thank you for the experience."
    },
    p3: {
      fr: "Je suis née prête pour ce qui vient.",
      en: "I was born ready for what comes next."
    }
  },

  // CTA
  cta: {
    button: {
      fr: "Explorer COCON SACRÉ en détail",
      en: "Explore COCON SACRÉ in detail"
    }
  },

  // Back link
  back: {
    fr: "Retour",
    en: "Back"
  }
};

export default jeinarStoryTranslations;
